// extracted by mini-css-extract-plugin
module.exports = {"header":"NotFound_header__QTyRo","title":"NotFound_title__LN1f5","intro":"NotFound_intro__rIf8A"};